import type { ClienteRanking, FiltroRanking } from "../../../services/posicaoClientes"

export type { ClienteRanking, FiltroRanking }

export interface PosicaoClientesModel {
    clientes: ClienteRanking[]
    filtro: FiltroRanking
    sortudo: ClienteRanking | null
}

function dataHoje(): string {
    const hoje = new Date()
    const dia = String(hoje.getDate()).padStart(2, "0")
    const mes = String(hoje.getMonth() + 1).padStart(2, "0")
    const ano = hoje.getFullYear()
    return `${dia}/${mes}/${ano}`
}

function primeiroDiaMes(): string {
    const hoje = new Date()
    const mes = String(hoje.getMonth() + 1).padStart(2, "0")
    const ano = hoje.getFullYear()
    return `01/${mes}/${ano}`
}

export const FiltroInicial: FiltroRanking = {
    dataInicio: primeiroDiaMes(),
    dataFinal: dataHoje(),
    tipoRanking: 1,
    apenasPrimeiraCompra: 0,
}

export const PosicaoClientesInicial: PosicaoClientesModel = {
    clientes: [],
    filtro: FiltroInicial,
    sortudo: null,
}
